export default __webpack_public_path__ + "static/media/GY.18dc7263.svg";